.ctaLink {
  color: #0070d2;
  cursor: pointer;
  opacity: 0.85;
  text-decoration: none;
  
  &.normal {
    font-size: 14px;
  }

  &.small {
    font-size: 14px;
  }
  
  &.extraSmall {
    font-size: 11px;
  }

  &.medium {
    font-size: 16px;
  }
  
  &.large {
    font-size: 18px;
  }
  
  &.normal {
    font-weight: 300;
  }

  &.bold {
    font-weight: 400;
  }

  &.extraBold {
    font-weight: 700;
  }

  &.thin {
    font-weight: 100;
  }
  
  &:hover {
    color: #005fb2;
  }

  &.disabled {
    pointer-events: none;
  }
  
  &.darkMode {
    color: #34BB8A;
    
    &:hover {
      color: #35CD96;
    }
  }
  
  &.button {
    padding: 11px;
    background: #0070d2;
    border-radius: 10px;
    color: white;
    font-size: 15px;
    font-weight: 300;
    transition: background 0.5s ease;

    &:hover {
      background-color: #005fb2;
    }
  }
  
  &.button.disabled {
    border-color: #c9c7c5;
    background-color: #c9c7c5;
    color: #fff;
    cursor: default;
  }
}
